import styled from 'styled-components';

import { RISE } from '../ExampleQuestionPanel.styles';

export const ShortcutBarRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  animation: ${RISE} 260ms ease both;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const ShortcutBarLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--gray-dark);

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: linear-gradient(to right, var(--gray-light), transparent);
  }
`;
